import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { useStepValidationFailed } from './StepValidationContext';

/**
 * "Täytä/tarkista kaikki pakolliset kentät" -viesti, joka näytetään vaiheen napin
 * yläpuolella, kun NextStepButton/SubmitButton on merkinnyt vaiheen validoinnin
 * epäonnistuneeksi. Nollautuu vaiheen vaihtuessa (StepValidationContext).
 */
const StepFailMessage: FC = () => {
    const { t } = useTranslation();
    const failed = useStepValidationFailed();
    if (!failed) return null;
    return (
        <Typography role='alert' variant='body1' style={{ color: 'red', width: '100%', margin: '8px 0' }}>
            {t('apartment.actions.stepFail')}
        </Typography>
    );
};

export default StepFailMessage;
